module.exports = __webpack_public_path__ + "assets/img/arrowDown.57672a39.svg";